import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import WSCBlazeLiveContentBlockComponent from './js/wsc-blaze-live-content-block.component';

ComponentsFactory.getInstance().define('wsc-blaze-live-content-block', WSCBlazeLiveContentBlockComponent);
